import { Portal } from '@mui/material';
import React from 'react';
import { Alert, Snackbar } from '@/theme/components';

interface PaymentsFeedbackProps {
  message: string;
  severity: 'error' | 'info' | 'success' | 'warning';
  showSnackBar: boolean;
  setShowSnackBar: (showSnackBar: boolean) => void;
}

export const PaymentsFeedback = (props: PaymentsFeedbackProps) => {
  return (
    <>
      {props.showSnackBar && (
        <Portal>
          <Snackbar
            open={props.showSnackBar}
            autoHideDuration={10000}
            onClose={(_, reason?) => {
              if (reason === 'clickaway') return;
              props.setShowSnackBar(false);
            }}
          >
            <Alert
              onClose={() => props.setShowSnackBar(false)}
              severity={props.severity}
              variant="filled"
            >
              {props.message}
            </Alert>
          </Snackbar>
        </Portal>
      )}
    </>
  );
};
